import { createFileRoute } from '@tanstack/react-router';

import { Legal } from '@/components/content/Legal';

export const Route = createFileRoute('/_map/_sidebar/legal')({
  beforeLoad: ({ search }) => {
    const { resultIndex, ...rest } = search as { resultIndex?: number } & Record<string, unknown>;

    return { search: rest };
  },
  component: Legal,
});
